module.exports = __webpack_public_path__ + "img/tartinerouge_on.c045964a.gif";